<template>
  <b-container>
    <h2>Membership Form</h2>
    <b-form @submit.prevent="save">
      <!-- Effective Date -->
      <b-form-group label="Effective Date">
        <b-form-datepicker
          v-model="effective_date"
          locale="en"
        ></b-form-datepicker>
      </b-form-group>

      <!-- Expiration Date -->
      <b-form-group label="Expiration Date">
        <b-form-datepicker
          v-model="expiration_date"
          locale="en"
        ></b-form-datepicker>
      </b-form-group>

      <!-- Verify Info Message -->
      <b-form-group label="Verify Information Message">
        <b-form-textarea
          v-model="form.verify_info_message"
          rows="3"
        ></b-form-textarea>
      </b-form-group>

      <!-- Agree Terms Message -->
      <b-form-group label="Agreement Message">
        <b-form-textarea
          v-model="form.agree_terms_message"
          rows="3"
        ></b-form-textarea>
      </b-form-group>

      <!-- Terms Title -->
      <b-form-group label="Terms Title">
        <b-form-input v-model="form.terms_title"></b-form-input>
      </b-form-group>

      <!-- Terms Sections -->
      <b-card class="mb-3">
        <h5>Terms Sections</h5>

        <div
          v-for="(section, index) in form.terms_sections"
          :key="index"
          class="mb-4"
        >
          <b-form-group :label="'Section Title ' + (index + 1)">
            <b-form-input v-model="section.section_title"></b-form-input>
          </b-form-group>

          <b-form-group :label="'Section Content ' + (index + 1)">
            <b-form-textarea
              v-model="section.section_content"
              rows="5"
            ></b-form-textarea>
          </b-form-group>

          <b-button variant="danger" size="sm" @click="removeSection(index)">
            Remove Section
          </b-button>

          <hr />
        </div>

        <b-button variant="primary" @click="addSection">
          Add Section
        </b-button>
      </b-card>

      <!-- Terms Links -->
      <b-card class="mb-3">
        <h5>Terms Links</h5>

        <div
          v-for="(link, index) in form.terms_links"
          :key="index"
          class="mb-4"
        >
          <b-form-group :label="'Link Title ' + (index + 1)">
            <b-form-input v-model="link.link_title"></b-form-input>
          </b-form-group>

          <b-form-group :label="'Link URL ' + (index + 1)">
            <b-form-input v-model="link.link_content"></b-form-input>
          </b-form-group>

          <b-button variant="danger" size="sm" @click="removeLink(index)">
            Remove Link
          </b-button>

          <hr />
        </div>

        <b-button variant="primary" @click="addLink">
          Add Link
        </b-button>
      </b-card>

      <!-- Submit -->
      <b-button
        type="submit"
        variant="success"
        :disabled="working"
        :loading="working"
      >
        Save Changes
      </b-button>
    </b-form>
  </b-container>
</template>

<script>
import { mapState } from "vuex";

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export default {
  data() {
    console.log(this.semester);
    const now = new Date(Date.now());
    return {
      effective_date: now.toISOString(), // Default to today
      expiration_date: null,
      form: {
        verify_info_message: "",
        agree_terms_message: "",
        terms_title: "",
        terms_sections: [],
        terms_links: [],
      },
      working: false,
    };
  },
  created() {
    // Load initial JSON here
    this.$api
      .get("/api/membership/admin/membership-form-version")
      .then((response) => {
        console.log(response);
        this.form = JSON.parse(response.data.membership_form_version.form);
      });
  },
  methods: {
    addSection() {
      this.form.terms_sections.push({
        section_title: "",
        section_content: "",
      });
    },
    removeSection(index) {
      this.form.terms_sections.splice(index, 1);
    },
    addLink() {
      this.form.terms_links.push({
        link_title: "",
        link_content: "",
      });
    },
    removeLink(index) {
      this.form.terms_links.splice(index, 1);
    },
    save() {
      this.working = true;
      this.$api
        .post("/api/membership/admin/membership-form-version", {
          effective_date: this.effective_date,
          expiration_date: this.expiration_date,
          form: JSON.stringify(this.form),
        })
        .then((response) => {
          this.$bvToast.toast(response.data.message, {
            title: "Notification",
            autoHideDelay: 5000,
            appendToast: true,
          });
        })
        .finally(() => {
          this.working = false;
        });
    },
  },
  computed: mapState(["semester"]),
  watch: {
    semester(newSemester) {
      if (this.expiration_date == null && newSemester) {
        this.expiration_date =
          this.semester && this.semester.membership_period
            ? addDays(new Date(), this.semester.membership_period).toISOString()
            : this.semester.stop_date;
      }
    },
  },
};
</script>
